<dx-chart
  class="chart"
  palette="bright"
  [dataSource]="data">
  <dxo-title horizontalAlignment="center" text="Olympic Medals in 2008">
    <dxo-font [weight]="300" [size]="18"></dxo-font>
  </dxo-title>
  <!--<dxo-adaptive-layout [height]="300" [width]="400"></dxo-adaptive-layout>-->
  <dxo-legend
    orientation="horizontal"
    itemTextPosition="right"
    horizontalAlignment="center"
    verticalAlignment="bottom"
    [columnCount]="4"></dxo-legend>
  <dxo-export [enabled]="false"></dxo-export>
  <dxi-series
    argumentField="day"
    valueField="oranges"
    name="My oranges"
    type="bar">
  </dxi-series>
</dx-chart>
